"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingLinkButton = exports.SettingDangerButton = exports.SettingDefaultButton = exports.SettingPrimaryButton = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/styles");
var styles_2 = require("@material-ui/core/styles");
var PropTypes = tslib_1.__importStar(require("prop-types"));
var Button_1 = tslib_1.__importDefault(require("@material-ui/core/Button"));
var colors_1 = require("@material-ui/core/colors");
var useStyles = styles_1.makeStyles({
    Wrap: {
        width: "100%",
        height: 44,
    },
    SelectButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        cursor: "pointer",
    },
    SettingLinkButton: {
        color: "rgb(0, 176, 244)",
        textDecoration: "none",
        cursor: "pointer",
    },
});
var PrimaryButton = styles_2.withStyles(function (theme) { return ({
    root: {
        color: theme.palette.getContrastText(colors_1.blue[600]),
        backgroundColor: "rgb(115,139,216)",
        "&:hover": {
            backgroundColor: "rgb(104,125,194)",
        },
    },
}); })(Button_1.default);
var DefaultButton = styles_2.withStyles({
    root: {
        color: colors_1.blue[600],
        borderColor: colors_1.blue[600],
        "&:hover": {
            color: colors_1.blue[700],
            borderColor: colors_1.blue[700],
        },
    },
})(Button_1.default);
var DangerButton = styles_2.withStyles({
    root: {
        color: colors_1.red[500],
        borderColor: colors_1.red[500],
        "&:hover": {
            color: colors_1.red[700],
            borderColor: colors_1.red[700],
        },
    },
})(Button_1.default);
function SettingPrimaryButton(props) {
    var children = props.children, onClick = props.onClick;
    return (React.createElement("div", tslib_1.__assign({ "data-value": children }, props),
        React.createElement(PrimaryButton, { variant: "contained", color: "primary", onClick: onClick }, children)));
}
exports.SettingPrimaryButton = SettingPrimaryButton;
function SettingDefaultButton(props) {
    var children = props.children, onClick = props.onClick;
    return (React.createElement("div", null,
        React.createElement(DefaultButton, tslib_1.__assign({ variant: "outlined", color: "primary", onClick: onClick }, props), children)));
}
exports.SettingDefaultButton = SettingDefaultButton;
function SettingDangerButton(props) {
    var children = props.children, onClick = props.onClick;
    return (React.createElement("div", null,
        React.createElement(DangerButton, tslib_1.__assign({ variant: "outlined", color: "primary", onClick: onClick }, props), children)));
}
exports.SettingDangerButton = SettingDangerButton;
function SettingLinkButton(props) {
    var children = props.children, href = props.href;
    var classes = useStyles();
    return (React.createElement("p", null,
        React.createElement("a", { className: classes.SettingLinkButton, href: href }, children)));
}
exports.SettingLinkButton = SettingLinkButton;
SettingPrimaryButton.protoTypes = {
    children: PropTypes.string,
};
SettingPrimaryButton.defaultProps = {
    children: "Button",
};
SettingDefaultButton.protoTypes = {
    children: PropTypes.string,
};
SettingDefaultButton.defaultProps = {
    children: "Button",
};
SettingDangerButton.protoTypes = {
    children: PropTypes.string,
};
SettingDangerButton.defaultProps = {
    children: "Button",
};
SettingLinkButton.protoTypes = {
    children: PropTypes.string,
};
SettingLinkButton.defaultProps = {
    children: "Link",
};
//# sourceMappingURL=index.js.map